import type { Testkit, UniDriver } from 'ricos-types/testkit';

import { SELECTION_CLASS } from './constants';

export type SelectionTestkit = Testkit<{
  content: {
    getSelection: () => Promise<UniDriver<Element>>;
  };
}>;

export const createSelectionHighlightTestkit: SelectionTestkit = (
  getBase: () => UniDriver<Element>
) => {
  return {
    content: {
      getSelection: async () => {
        return getBase().get(`.${SELECTION_CLASS}`);
      },
    },
  };
};
